export const CATEGORIES_LABORATOIRE = [
    { id: 'reactifs', nom: 'Réactifs' },
    { id: 'prelevement', nom: 'Contenants de prélèvement' },
    { id: 'soins', nom: 'Consommables de soins' }
]

export const CATEGORIES_HOSPITALISATION = [
    { id: 'medicaments', nom: 'Médicaments' },
    { id: 'soins', nom: 'Consommables de soins' },
    { id: 'prelevement', nom: 'Contenants de prélèvement' }
]

export function attributsArticle(article) {
    const brut = article && article.attribut ? article.attribut : {}
    if (typeof brut !== 'string') return brut
    try { return JSON.parse(brut) || {} } catch (error) { return {} }
}

export function categorieArticle(article) {
    if (Number(article.type_article_id) === 1) return 'medicaments'
    const attributs = attributsArticle(article)
    const famille = String(attributs.Famille || '').toLocaleLowerCase('fr')
    if (attributs['Code contenant'] || /pr[eé]l[eè]vement|contenant/.test(famille)) return 'prelevement'
    if (/r[eé]actif/.test(famille)) return 'reactifs'
    return 'soins'
}

export function familleArticle(article) {
    const attributs = attributsArticle(article)
    if (categorieArticle(article) === 'medicaments') {
        return String(attributs['Catégorie'] || attributs.Categorie || 'Autres médicaments').trim()
    }
    return String(attributs.Famille || '').trim()
}

export function sectionsArticles(articles, definitions, recherche = '') {
    const terme = String(recherche).trim().toLocaleLowerCase('fr')
    return definitions.map(definition => {
        const produits = articles.filter(article => categorieArticle(article) === definition.id
            && (!terme || String(article.libelle || '').toLocaleLowerCase('fr').includes(terme)))
        const groupes = []
        produits.forEach(article => {
            const famille = definition.id === 'medicaments' ? familleArticle(article) : ''
            let groupe = groupes.find(item => item.nom === famille)
            if (!groupe) { groupe = { nom: famille, produits: [] }; groupes.push(groupe) }
            groupe.produits.push(article)
        })
        groupes.sort((a, b) => a.nom.localeCompare(b.nom, 'fr'))
        return { ...definition, produits, groupes }
    })
}
